import React from 'react';
import { Button } from './Button';
import { BoxIcon } from 'lucide-react';
interface ErrorStateProps {
  icon: BoxIcon;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
  variant?: 'destructive' | 'warning';
}
export function ErrorState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  className = '',
  variant = 'destructive'
}: ErrorStateProps) {
  const colorClass = variant === 'destructive' ? 'text-destructive' : 'text-[var(--status-standby)]';
  const borderColorClass = variant === 'destructive' ? 'border-destructive/30' : 'border-[var(--status-standby)]/30';
  const bgGlowClass = variant === 'destructive' ? 'shadow-[0_0_15px_rgba(var(--destructive),0.15)]' : 'shadow-[0_0_15px_rgba(var(--status-standby),0.15)]';
  const ringClass = variant === 'destructive' ? 'border-destructive/20' : 'border-[var(--status-standby)]/20';
  return <div className={`flex flex-col items-center justify-center p-12 text-center border border-dashed border-border/50 rounded-lg bg-black/20 ${className}`} data-id="element-158">
      <div className="relative mb-6" data-id="element-159">
        {/* Tactical Error Background Effect */}
        <div className="absolute inset-0 flex items-center justify-center" data-id="element-160">
          <div className={`w-24 h-24 rounded-full border ${ringClass} animate-[ping_3s_cubic-bezier(0,0,0.2,1)_infinite]`} data-id="element-161"></div>
          <div className={`absolute w-16 h-16 rounded-full border ${borderColorClass} animate-[ping_2s_cubic-bezier(0,0,0.2,1)_infinite]`} data-id="element-162"></div>
          <div className={`absolute w-32 h-32 rounded-full border ${ringClass}`} data-id="element-163"></div>
          {/* Crosshair / Warning Lines */}
          <div className={`absolute w-full h-[1px] ${ringClass} bg-current opacity-20 transform rotate-45`} data-id="element-164"></div>
          <div className={`absolute h-full w-[1px] ${ringClass} bg-current opacity-20 transform rotate-45`} data-id="element-165"></div>
        </div>

        {/* Icon Container */}
        <div className={`relative z-10 w-16 h-16 bg-black/60 border ${borderColorClass} rounded-xl flex items-center justify-center ${bgGlowClass} backdrop-blur-sm`} data-id="element-166">
          <Icon className={`w-8 h-8 ${colorClass} opacity-90`} data-id="element-167" />
        </div>
      </div>

      <h3 className={`text-sm font-mono font-bold uppercase tracking-widest ${colorClass} mb-2`} data-id="element-168">
        {title}
      </h3>
      <p className="text-xs font-mono text-muted-foreground max-w-sm leading-relaxed mb-6" data-id="element-169">
        {description}
      </p>

      {actionLabel && onAction && <Button variant="outline" onClick={onAction} className={`border-border/50 hover:bg-white/5 font-mono text-xs tracking-widest uppercase ${colorClass}`} data-id="element-170">
          {actionLabel}
        </Button>}
    </div>;
}